module.exports = __webpack_public_path__ + "img/Group.81b5fa6c.png";